import { AgValueSetter, AgPostSort, AgAutoCompleteEditor, AgDatePickerEditor, AgNumericEditor, AgCheckboxComponent } from "../../components";
import { Util } from "../../utils";

export class GridFareTransConfig {
  constructor(private pageComp: any) {

  }

  colDefFclTrans = [
    {
      headerName: '적용',
      field: 'activityYn',
      editable: true,
      cellRenderer: 'activityYnRenderer',
      width: 65
    },
    {
      headerName: '출발지',
      field: 'orgLocation',
      valueGetter: params => params.data && params.data.orgLocation && params.data.orgLocation.locationCd ? '[' + params.data.orgLocation.locationCd + '] ' + params.data.orgLocation.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : params =>  params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "orgLocationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.orgSelectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '도착지',
      field: 'desLocation',
      valueGetter: params => params.data && params.data.desLocation && params.data.desLocation.locationCd ? '[' + params.data.desLocation.locationCd + '] ' + params.data.desLocation.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : params =>  params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "desLocationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.desSelectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '포워더', 
      field: 'corp',
      valueGetter: params => params.data && params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '선사', 
      field: 'line',
      valueGetter: params => params.data && params.data.line && params.data.line.lineCd ? '[' + params.data.line.lineCd + '] ' + params.data.line.lineNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.lines, 'lineCd'),
      editable : params =>  params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "lineEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.lineAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: 'DIR/TS', 
      field: 'tsYn',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {values: ['Direct', 'T/S']},
      width: 80
    },
    {
      headerName: '통화',
      field: 'crncyCd',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "crncyEditor",
      cellRenderer: params => params.value ? params.value : '',
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 70
    },
    {
      headerName: '20’',
      field: 'cntr20Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "twEditor",
      filter: 'agNumberColumnFilter',
      width: 85
    },
    {
      headerName: '40’',
      field: 'cntr40Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "ftEditor",
      filter: 'agNumberColumnFilter',
      width: 85
    },
    {
      headerName: '40H’',
      field: 'cntrHcCost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "hcEditor",
      filter: 'agNumberColumnFilter',
      width: 85
    },
    {
      headerName: '유효시작일',
      field: 'availStrDt',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "availStrDtEditor",
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 100
    },
    {
      headerName: '유효종료일',
      field: 'availEndDt',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "availEndDtEditor",
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 100
    },
    { headerName: 'Included',
      children: [
        {
          headerName: 'L.THC',
          field: 'incOrgThcYn',
          editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
          cellRenderer: 'orgThcRenderer',
          width: 75
        },
        {
          headerName: 'D.THC',
          field: 'incDesThcYn',
          editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
          cellRenderer: 'desThcRenderer',
          width: 75
        }
      ]
    },
    {
      headerName: '저장일시',
      field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 150
    }
  ];
  

  frameworkCompsFclTrans = {
    orgLocationEditor: AgAutoCompleteEditor,
    desLocationEditor: AgAutoCompleteEditor,
    lineEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    availStrDtEditor : AgDatePickerEditor,
    availEndDtEditor : AgDatePickerEditor,
    twEditor: AgNumericEditor,
    ftEditor: AgNumericEditor,
    hcEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
    orgThcRenderer : AgCheckboxComponent,
    desThcRenderer : AgCheckboxComponent,
  };

  

  colDefLclTrans = [
    {
      headerName: '적용',
      field: 'activityYn',
      editable: true,
      cellRenderer: 'activityYnRenderer',
      width: 65
    },
    {
      headerName: '출발지',
      field: 'orgLocation',
      valueGetter: params => params.data && params.data.orgLocation && params.data.orgLocation.locationCd ? '[' + params.data.orgLocation.locationCd + '] ' + params.data.orgLocation.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "orgLocationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.orgSelectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '도착지',
      field: 'desLocation',
      valueGetter: params => params.data && params.data.desLocation && params.data.desLocation.locationCd ? '[' + params.data.desLocation.locationCd + '] ' + params.data.desLocation.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "desLocationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.desSelectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '포워더', 
      field: 'corp',
      valueGetter: params => params.data && params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '통화',
      field: 'crncyCd',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "crncyEditor",
      cellRenderer: params => params.value ? params.value : '',
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 70
    },
    {
      headerName: '단가',
      field: 'cbmCost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "cbmCostEditor",
      filter: 'agNumberColumnFilter',
      width: 85
    },
    {
      headerName: 'Min. C',
      field: 'minCost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "minCostEditor",
      filter: 'agNumberColumnFilter',
      width: 85
    },
    {
      headerName: '유효시작일',
      field: 'availStrDt',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "availStrDtEditor",
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 100
    },
    {
      headerName: '유효종료일',
      field: 'availEndDt',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "availEndDtEditor",
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 100
    },
    { headerName: 'Included',
      children: [
        {
          headerName: 'L.THC',
          field: 'incOrgThcYn',
          editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
          cellRenderer: 'orgThcRenderer',
          width: 75
        },
        {
          headerName: 'D.THC',
          field: 'incDesThcYn',
          editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
          cellRenderer: 'desThcRenderer',
          width: 75
        }
      ]
    },
    {
      headerName: '저장일시',
      field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 150
    }
  ];
  
  frameworkCompsLclTrans = {
    orgLocationEditor: AgAutoCompleteEditor,
    desLocationEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    availStrDtEditor : AgDatePickerEditor,
    availEndDtEditor : AgDatePickerEditor,
    cbmCostEditor: AgNumericEditor,
    minCostEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
    orgThcRenderer : AgCheckboxComponent,
    desThcRenderer : AgCheckboxComponent,
  };

  colDefAirTrans = [
    {
      headerName: '적용',
      field: 'activityYn',
      editable: true,
      cellRenderer: 'activityYnRenderer',
      width: 65
    },
    {
      headerName: '출발지',
      field: 'orgLocation',
      valueGetter: params => params.data && params.data.orgLocation && params.data.orgLocation.locationCd ? '[' + params.data.orgLocation.locationCd + '] ' + params.data.orgLocation.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : params => params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "orgLocationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.orgSelectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '도착지',
      field: 'desLocation',
      valueGetter: params => params.data && params.data.desLocation && params.data.desLocation.locationCd ? '[' + params.data.desLocation.locationCd + '] ' + params.data.desLocation.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : params => params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "desLocationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.desSelectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '포워더', 
      field: 'corp',
      valueGetter: params => params.data && params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '항공사', 
      field: 'line',
      valueGetter: params => params.data && params.data.line && params.data.line.lineCd ? '[' + params.data.line.lineCd + '] ' + params.data.line.lineNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.lines, 'lineCd'),
      editable : params => params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "lineEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.lineAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '통화',
      field: 'crncyCd',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "crncyEditor",
      cellRenderer: params => params.value ? params.value : '',
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 70
    },
    {
      headerName: 'Nor',
      field: 'kgCost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "kgEditor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: 'Min.',
      field: 'minCost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "minEditor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '45',
      field: 'air45Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "air45Editor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '100',
      field: 'air100Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "air100Editor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '250',
      field: 'air250Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "air250Editor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '300',
      field: 'air300Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "air300Editor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '500',
      field: 'air500Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "air500Editor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '1000',
      field: 'air1000Cost',
      cellRenderer: params => Util.numberFormat(params.value),
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "air1000Editor",
      filter: 'agNumberColumnFilter',
      width: 70
    },
    {
      headerName: '유효시작일',
      field: 'availStrDt',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "availStrDtEditor",
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 100
    },
    {
      headerName: '유효종료일',
      field: 'availEndDt',
      editable : params => params.data && params.data.isEditable(this.pageComp.myCorp.corpId),
      cellEditor: "availEndDtEditor",
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 100
    },
    {
      headerName: '저장일시',
      field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 150
    }
  ];

  frameworkCompsAirTrans = {
    orgLocationEditor: AgAutoCompleteEditor,
    desLocationEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    availStrDtEditor : AgDatePickerEditor,
    availEndDtEditor : AgDatePickerEditor,
    
    kgEditor: AgNumericEditor,
    minEditor: AgNumericEditor,
    air45Editor: AgNumericEditor,
    air100Editor: AgNumericEditor,
    air250Editor: AgNumericEditor,
    air300Editor: AgNumericEditor,
    air500Editor: AgNumericEditor,
    air1000Editor: AgNumericEditor,

    activityYnRenderer : AgCheckboxComponent,
  };

}


// WEBPACK FOOTER //
// ./src/app/containers/fare/fare-management-grid-trans.ts